<template>
  <v-container fluid tag="section" class="mt-1">
    <v-row>
      <v-col cols="12" :class="$isMobile ? 'size-13' : ''">
        公告标题：<span class="font-weight-black">{{item.title}}（{{item.createTime | formatDate}}）</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" :class="$isMobile ? 'size-13' : ''">
        <v-card outlined class="pa-2">
          <span class="font-weight-black" style="white-space: pre-line" v-html="item.content"></span>
        </v-card>
      </v-col>
    </v-row>

    <div>
      <v-card-title class="pl-0 green--text">已读人员({{item.reads.length}})</v-card-title>
      <v-card-text class="pl-0">
        <v-chip pill v-for="(i, idx) in item.reads" :key="idx" class="ma-2">
          <v-avatar left>
            <v-img :src="i.createUser.avatar"></v-img>
          </v-avatar>
          {{i.createUser.name}}
        </v-chip>
      </v-card-text>
      <v-card-title class="pl-0 red--text">未读人员({{item.unReadUsers.length}})</v-card-title>
        <v-card-text class="pl-0">
          <v-chip pill v-for="(i, idx) in item.unReadUsers" :key="idx" class="ma-2">
            <v-avatar left>
              <v-img :src="i.avatar"></v-img>
            </v-avatar>
            {{i.name}}
          </v-chip>
        </v-card-text>
    </div>
  </v-container>
</template>

<script>
  export default {
    name: 'NoticeDetail',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({})
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      }
    },
    computed: {
      bookkeeping () {
        return this.$constants.ProductType.Bookkeeping.indexOf(this.item.productId) !== -1
      }
    },
  }
</script>

<style lang="scss" scoped>
.order {
  position: absolute;
  z-index: 1;
  left: 250px;
  top: 25px;
  img{
    width: 120px;
    -moz-transform: rotate(-30deg);
    -webkit-transform: rotate(-30deg);
  }
}
</style>
